import type {Card} from '@platform/contracts/x';
import {Button} from './Button';
import {useCopy} from './config';
import {cardLabel} from './cardLabel';
import {CardAmountBadge} from './CardAmountBadge';

// Accepted stake is information, outside the separate draft/next-draw action.
export function CardPurchaseAction({card,currency,selected,disabled,busy,onSelect,nextDraw=false}:{card:Card;currency:string;selected:boolean;disabled:boolean;busy:boolean;onSelect:()=>void;nextDraw?:boolean}){
 const t=useCopy(),action=t(nextDraw?'room.pickNext':selected?'selection.remove':card.ownMinor>0?'card.add':'card.select');
 const label=t('card.label')+' '+cardLabel(card)+': '+(selected?t('selection.removeCard'):action);
 return <>
 {card.ownMinor>0&&<CardAmountBadge className={nextDraw?'card-owned-amount':'card-purchase-own'} minor={card.ownMinor} currency={currency}/>}
 <Button className={'card-fund-action add-button'+(nextDraw?' card-next-purchase':'')} aria-label={label} title={label} aria-pressed={selected} disabled={disabled} aria-busy={busy} onClick={onSelect}>
  <span className="card-fund-face">
   {card.ownMinor<=0&&<span className="card-fund-label">{nextDraw?t(selected?'selection.remove':'card.select'):action}</span>}
   <span className="card-fund-plus" data-action={selected?'remove':'add'} aria-hidden="true">{busy?'…':<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d={selected?'M5 12h14':'M12 5v14M5 12h14'}/></svg>}</span>
  </span>
 </Button></>;
}
